import { render } from "./ClaimIndex.vue?vue&type=template&id=bfc96bda"
import script from "./ClaimIndex.vue?vue&type=script&lang=js"
export * from "./ClaimIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__